/* ============================================================
   I AM LUIGI — Custom UX & Brand Improvements
   Draft theme • v8.0 • 2026-07-24
   ============================================================ */

(function () {
  'use strict';

  /* ———— CONFIG —————————————————————————————————————— */
  var IAL_REVIEWS = [
    { text: 'Strakke snelle service! Top kwaliteit. Fijne mensen.', name: 'Joey de Kruijf', source: 'Google Review • ★★★★★' },
    { text: 'Geweldige mannen. Ben groot afnemer en groot fan.', name: 'Negan', source: 'Google Review • ★★★★★' },
    { text: 'Uiteindelijk fantastische kleding gekocht. Gun jezelf ook deze ervaring.', name: 'Leroy Resodihardjo', source: 'Google Review • ★★★★★' }
  ];

  var IAL_COLLECTION_HANDLES = [
    { handle: 'de-collectie', label: 'De Collectie' },
    { handle: 'najaarscollectie', label: 'Najaarscollectie' },
    { handle: 'knitwear', label: 'Knitwear' },
    { handle: 'schoenen-1', label: 'Schoenen' }
  ];

  /* ———— HELPERS ————————————————————————————————————— */
  function formatPrice(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',').replace(/,00$/, ',-');
  }

  function isHomepage() {
    return window.location.pathname === '/' || window.location.pathname === '';
  }

  function isProductPage() {
    return window.location.pathname.indexOf('/products/') !== -1;
  }

  /* ———— SORT SOLD OUT ——————————————————————————————————— */
  function sortSoldOutToBottom() {
    var cards = document.querySelectorAll('.card-wrapper, .product-card-wrapper, [data-product-card]');
    cards.forEach(function (card) {
      var badges = card.querySelectorAll('.badge--sold-out, [class*="sold-out"], [class*="soldout"]');
      if (badges.length > 0) {
        card.classList.add('ial--sold-out-card');
        var parent = card.parentElement;
        if (parent) parent.appendChild(card);
      }
    });
  }

  /* ———— FIX COLOUR LABEL ————————————————————————————————— */
  function fixColourLabel() {
    document.querySelectorAll('label, legend, .product-form__label, .product-form__input label').forEach(function (el) {
      if (/^(colour|color)$/i.test(el.textContent.trim())) {
        el.textContent = 'Kleur';
      }
    });
  }

  /* ———— BREADCRUMBS —————————————————————————————————————— */
  function initBreadcrumbs() {
    var path = window.location.pathname;
    var isProduct = path.indexOf('/products/') !== -1;
    var isCollection = path.indexOf('/collections/') !== -1;
    var isPage = path.indexOf('/pages/') !== -1;
    if (!isProduct && !isCollection && !isPage) return;

    var heading = document.querySelector('.product__title, h1.product-title, h1.title, .collection__title h1, .page__title');
    if (!heading) return;

    var crumb = document.createElement('nav');
    crumb.className = 'ial-breadcrumb';
    crumb.setAttribute('aria-label', 'Broodkruimelpad');

    var parts = [];
    parts.push('<a href="/">Home</a>');

    if (isProduct) {
      var collHandleMatch = document.referrer.match(/\/collections\/([^/?#]+)/);
      if (collHandleMatch) {
        var collHandle = collHandleMatch[1];
        var collLabel = collHandle.replace(/-/g, ' ').replace(/\w/g, function (c) { return c.toUpperCase(); });
        parts.push('<a href="/collections/' + collHandle + '">' + collLabel + '</a>');
      } else {
        parts.push('<a href="/collections/all">Shop</a>');
      }
      var titleText = heading.textContent.trim();
      parts.push('<span class="ial-breadcrumb__current">' + titleText + '</span>');
    } else if (isCollection) {
      var titleEl = heading;
      parts.push('<span class="ial-breadcrumb__current">' + (titleEl ? titleEl.textContent.trim() : 'Collectie') + '</span>');
    } else if (isPage) {
      var pageTitleEl = heading;
      parts.push('<span class="ial-breadcrumb__current">' + (pageTitleEl ? pageTitleEl.textContent.trim() : 'Pagina') + '</span>');
    }

    crumb.innerHTML = parts.join('<span class="ial-breadcrumb__sep">/</span>');
    heading.parentNode.insertBefore(crumb, heading);
  }

  /* ———— STICKY ATC BAR (mobile) —————————————————————————————— */
  function initStickyATC() {
    if (!isProductPage()) return;
    if (window.innerWidth > 768) return;

    var addBtn = document.querySelector('.product-form button[name="add"], .product-form button[type="submit"]');
    var productTitle = document.querySelector('.product__title, h1.product-title, .product__info-title');
    if (!addBtn) return;

    var bar = document.createElement('div');
    bar.id = 'ial-sticky-cart-bar';
    var titleText = productTitle ? productTitle.textContent.trim() : '';
    bar.innerHTML = '<span class="ial-sticky-title">' + titleText + '</span><button class="ial-sticky-btn">In winkelwagen</button>';
    document.body.appendChild(bar);

    bar.querySelector('.ial-sticky-btn').addEventListener('click', function () {
      addBtn.click();
    });

    var observer = new IntersectionObserver(function (entries) {
      bar.style.display = entries[0].isIntersecting ? 'none' : '';
    }, { threshold: 0.5 });
    observer.observe(addBtn);
  }

  /* ———— TRUST BAR (homepage) ——————————————————————————————————— */
  function initTrustBar() {
    if (!isHomepage()) return;
    var main = document.querySelector('main, .main-content, #MainContent, [role="main"]');
    if (!main) return;

    var bar = document.createElement('div');
    bar.id = 'ial-trust-bar';
    bar.innerHTML = [
      '<ul class="ial-trust-bar__list">',
      '<li class="ial-trust-bar__item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>Gratis verzending vanaf €100</li>',
      '<li class="ial-trust-bar__item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>Veilig betalen</li>',
      '<li class="ial-trust-bar__item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>De Boetiek in Voorburg</li>',
      '<li class="ial-trust-bar__item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.07 12a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 3 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 5.61 5.61l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>Persoonlijk advies</li>',
      '</ul>'
    ].join('');
    main.insertAdjacentElement('beforebegin', bar);
  }

  /* ———— PRODUCT TRUST BLOCK ————————————————————————————————— */
  function initProductTrust() {
    if (!isProductPage()) return;
    var form = document.querySelector('.product-form, form[action*="/cart/add"]');
    if (!form) return;

    var block = document.createElement('div');
    block.className = 'ial-product-trust';
    block.innerHTML = [
      '<div class="ial-product-trust__item"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg><span><strong>Gratis verzending</strong>Vanaf €100 in Nederland</span></div>',
      '<div class="ial-product-trust__item"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg><span><strong>Passen in de boetiek</strong>Herenstraat 85A, Voorburg</span></div>',
      '<div class="ial-product-trust__item"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg><span><strong>Zorgvuldig geselecteerd</strong>Premium kwaliteit, persoonlijke keuze</span></div>'
    ].join('');
    form.insertAdjacentElement('afterend', block);
  }

  /* ———— PRODUCT STORY BLOCK ————————————————————————————————— */
  function initProductStory() {
    if (!isProductPage()) return;
    setTimeout(function () {
      var trustBlock = document.querySelector('.ial-product-trust');
      if (!trustBlock) return;
      var story = document.createElement('div');
      story.className = 'ial-product-story';
      story.innerHTML = [
        '<p class="ial-product-story__label">I am Luigi</p>',
        '<p class="ial-product-story__text">Elk stuk in de boetiek is met zorg geselecteerd — op pasvorm, materiaal en draagbaarheid. Niet omdat het moet, maar omdat goede kleding voelt als een tweede huid. Dat is waar I am Luigi voor staat.</p>'
      ].join('');
      trustBlock.insertAdjacentElement('afterend', story);
    }, 250);
  }

  /* ———— HOMEPAGE CONTENT (unified, guaranteed order) —————————————————— */

  function buildProductCard(product) {
    var img1 = (product.images && product.images[0]) ? product.images[0].src : '';
    var img2 = (product.images && product.images[1]) ? product.images[1].src : img1;
    var price = (product.variants && product.variants[0]) ? formatPrice(product.variants[0].price * 100) : '';
    var imgs = img1
      ? '<img class="ial-product-card__img ial-product-card__img--1" src="' + img1 + '" alt="' + product.title + '" loading="lazy"><img class="ial-product-card__img ial-product-card__img--2" src="' + img2 + '" alt="' + product.title + '" loading="lazy">'
      : '';
    return [
      '<a class="ial-product-card" href="/products/' + product.handle + '">',
        '<div class="ial-product-card__img-wrap">',
          imgs,
          '<div class="ial-product-card__view">Bekijk product</div>',
        '</div>',
        '<div class="ial-product-card__info">',
          '<p class="ial-product-card__title">' + product.title + '</p>',
          price ? '<p class="ial-product-card__price">' + price + '</p>' : '',
        '</div>',
      '</a>'
    ].join('');
  }

  function buildProductsSection(products) {
    var cards = products.map(buildProductCard).join('');
    var section = document.createElement('section');
    section.className = 'ial-products-section ial-fade-in';
    section.innerHTML = [
      '<div class="ial-products-inner">',
        '<div class="ial-products-header">',
          '<h2 class="ial-products-title">Nieuwe collectie</h2>',
          '<a class="ial-products-all" href="/collections/de-collectie">Alles bekijken</a>',
        '</div>',
        '<div class="ial-products-grid">' + cards + '</div>',
      '</div>'
    ].join('');
    return section;
  }

  function buildBrandStrip() {
    var section = document.createElement('section');
    section.className = 'ial-brand-strip ial-fade-in';
    section.innerHTML = [
      '<div class="ial-brand-strip__inner">',
        '<h2 class="ial-brand-strip__heading">Kleding die iets over je zegt.<br>Zonder dat je het hoeft uit te leggen.</h2>',
        '<div>',
          '<p class="ial-brand-strip__body">I am Luigi is een boetiek in Voorburg voor mannen die weten wat ze willen. Geen standaard rek, geen haastige keuzes. Alleen kleding die past bij wie je bent — geselecteerd met kennis van stijl, materiaal en draagbaarheid.</p>',
          '<a class="ial-brand-strip__cta" href="/pages/over-ons">Over de boetiek</a>',
        '</div>',
      '</div>'
    ].join('');
    return section;
  }

  function buildCollectionsSection(collections) {
    var tiles = IAL_COLLECTION_HANDLES.map(function (cfg) {
      var coll = collections.find(function (c) { return c.handle === cfg.handle; });
      var imgSrc = coll && coll.image ? coll.image.src : '';
      var img = imgSrc
        ? '<img class="ial-collection-tile__img" src="' + imgSrc + '" alt="' + cfg.label + '" loading="lazy">'
        : '<div class="ial-collection-tile__img" style="background:#E5E1D8;"></div>';
      return [
        '<a class="ial-collection-tile" href="/collections/' + cfg.handle + '">',
          '<div class="ial-collection-tile__img-wrap">',
            img,
            '<div class="ial-collection-tile__label"><p class="ial-collection-tile__title">' + cfg.label + '</p></div>',
          '</div>',
        '</a>'
      ].join('');
    }).join('');

    var section = document.createElement('section');
    section.className = 'ial-collections-section ial-fade-in';
    section.innerHTML = [
      '<div class="ial-collections-inner">',
        '<div class="ial-collections-header"><h2 class="ial-collections-title">Shop per categorie</h2></div>',
        '<div class="ial-collections-grid">' + tiles + '</div>',
      '</div>'
    ].join('');
    return section;
  }

  function buildTestimonialsSection() {
    var cards = IAL_REVIEWS.map(function (r) {
      var stars = '<div class="ial-testimonial__stars">' + '<div class="ial-testimonial__star"></div>'.repeat(5) + '</div>';
      return [
        '<figure class="ial-testimonial">',
          stars,
          '<blockquote class="ial-testimonial__text">"' + r.text + '"</blockquote>',
          '<figcaption class="ial-testimonial__author">',
            '<p class="ial-testimonial__name">' + r.name + '</p>',
            '<p class="ial-testimonial__source">' + r.source + '</p>',
          '</figcaption>',
        '</figure>'
      ].join('');
    }).join('');

    var section = document.createElement('section');
    section.className = 'ial-testimonials ial-fade-in';
    section.innerHTML = [
      '<div class="ial-testimonials__inner">',
        '<div class="ial-testimonials__header">',
          '<h2 class="ial-testimonials__label">Wat klanten zeggen</h2>',
          '<span class="ial-testimonials__rating">4.9 ★ Google</span>',
        '</div>',
        '<div class="ial-testimonials__grid">' + cards + '</div>',
      '</div>'
    ].join('');
    return section;
  }

  function buildEditorialCTA() {
    var section = document.createElement('section');
    section.className = 'ial-editorial-cta ial-fade-in';
    section.innerHTML = [
      '<div class="ial-editorial-cta__inner">',
        '<p class="ial-editorial-cta__label">De Boetiek</p>',
        '<h2 class="ial-editorial-cta__heading">Kleding kopen is één ding.<br>Goed gekleed gaan is iets anders.</h2>',
        '<p class="ial-editorial-cta__body">In de boetiek nemen we de tijd. Voor je stijl, je pasvorm, en het gevoel dat je wilt uitstralen. Maak een afspraak en ontdek het verschil.</p>',
        '<a class="ial-editorial-cta__btn" href="/pages/contact">Maak een afspraak</a>',
        '<address class="ial-editorial-cta__address">Herenstraat 85A &nbsp;·&nbsp; 2271 CC Voorburg</address>',
      '</div>'
    ].join('');
    return section;
  }

  function initHomepageContent() {
    if (!isHomepage()) return;
    var main = document.querySelector('main, .main-content, #MainContent, [role="main"]');
    if (!main) return;

    // Find the hero / first section inside main as anchor
    var hero = main.querySelector('[class*="hero"], [class*="slideshow"], [class*="banner"], section:first-child, .shopify-section:first-child');
    var anchor = hero || main.firstElementChild || main;

    // Chain: fetch products → insert products + brand strip → fetch collections → insert collections → insert testimonials → insert CTA
    fetch('/collections/de-collectie/products.json?limit=8&fields=id,title,handle,images,variants')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.products || [];
        var productsSection = buildProductsSection(products);
        var brandStrip = buildBrandStrip();

        anchor.insertAdjacentElement('afterend', brandStrip);
        anchor.insertAdjacentElement('afterend', productsSection);

        // Now fetch collections
        return fetch('/collections.json?limit=50&fields=id,title,handle,image')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var collections = data.collections || [];
            var collectionsSection = buildCollectionsSection(collections);
            var testimonialsSection = buildTestimonialsSection();
            var editorialCTA = buildEditorialCTA();

            brandStrip.insertAdjacentElement('afterend', collectionsSection);
            collectionsSection.insertAdjacentElement('afterend', testimonialsSection);
            testimonialsSection.insertAdjacentElement('afterend', editorialCTA);

            initScrollAnimations();
          });
      })
      .catch(function (err) {
        console.warn('[I am Luigi] Homepage content fout:', err);
      });
  }

  /* ———— SCROLL FADE-IN ANIMATIONS ——————————————————————————————— */
  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: show all
      document.querySelectorAll('.ial-fade-in').forEach(function (el) { el.classList.add('ial--in-view'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ial--in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06 });

    document.querySelectorAll('.ial-fade-in').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ———— NEWSLETTER POPUP (homepage only) ——————————————————————————— */
  function initNewsletterPopup() {
    if (!isHomepage()) return;
    var overlay = document.getElementById('ial-nl-popup-overlay');
    if (!overlay) return;
    try { if (localStorage.getItem('ial_nl_done')) return; } catch (e) {}

    var popup = document.getElementById('ial-nl-popup');
    var closeBtn = document.getElementById('ial-nl-popup-close');
    var skipBtn = document.getElementById('ial-nl-popup-skip');
    var emailInput = document.getElementById('ial-nl-popup-email');
    var body = document.getElementById('ial-nl-popup-body');
    var form = document.getElementById('ial-popup-nl-form');
    if (!popup || !form) return;

    function showPopup() {
      overlay.classList.add('ial--visible');
      document.body.style.overflow = 'hidden';
    }

    function closePopup() {
      overlay.classList.remove('ial--visible');
      document.body.style.overflow = '';
      try { localStorage.setItem('ial_nl_done', '1'); } catch (e) {}
    }

    setTimeout(showPopup, 6000);

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (skipBtn) skipBtn.addEventListener('click', closePopup);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = emailInput ? emailInput.value.trim() : '';
      if (!email) return;

      fetch('/contact#contact_form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: 'contact[email]=' + encodeURIComponent(email) + '&contact[tags]=nieuwsbrief&form_type=customer&utf8=%E2%9C%93'
      }).then(function () {
        if (body) body.innerHTML = '<p class="ial-nl-popup__ok">✅ Bedankt! Je staat ingeschreven voor de nieuwsbrief van I am Luigi.</p>';
        try { localStorage.setItem('ial_nl_done', '1'); } catch (e) {}
        setTimeout(closePopup, 2800);
      }).catch(function () {
        if (body) body.innerHTML = '<p class="ial-nl-popup__ok">✅ Bedankt! Je bent ingeschreven.</p>';
        try { localStorage.setItem('ial_nl_done', '1'); } catch (e) {}
        setTimeout(closePopup, 2800);
      });
    });
  }

  /* ———— INIT ——————————————————————————————————————————————— */
  function init() {
    sortSoldOutToBottom();
    fixColourLabel();
    initBreadcrumbs();
    initStickyATC();
    initTrustBar();
    initProductTrust();
    initProductStory();
    initHomepageContent();
    initNewsletterPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
